module.exports = __webpack_public_path__ + "img/tochilki.dd0d5b71.svg";